import { Slide } from '@/components/core/Slide';
import audioFile from './27-ai-readiness.mp3';

// const autoNextDuration = 21000;
const transcript = `
  Je vindt mij wel knapper dan ChatGPT toch?

  Ik... grapje...

  En als we het over AI readiness hebben Jonathan, dan kijken we niet alleen naar AI maar ook naar de processen toch? 
  Daar valt vaak al veel te optimaliseren zonder AI, en dit kijken naar je processen en te documenteren is belangrijk 
  om later agentic AI te kunnen gebruiken toch?
`;

// Jonathan: Absoluut. AI is geen magische oplossing die je zomaar kunt toevoegen aan een inefficiënt proces.
// Voordat je AI implementeert, moet je eerst je processen optimaliseren. Kijk kritisch naar wat je doet en waarom.
// Digitaliseer eerst, automatiseer daarna, en pas dan kun je AI effectief inzetten.
// Dit is waar veel MKB-bedrijven winst kunnen behalen: eerst de basis op orde brengen.
// En inderdaad, goede documentatie is cruciaal voor agentic AI die zelfstandig taken moet kunnen uitvoeren.

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      // autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-10">Tip: Processen Eerst</h1>
      </div>
    </Slide>
  );
};
